import { useEffect } from "react";
import usePaymentLedgerHook from "@/shared/hooks/usePaymentLedgerHook";
import {
  useReadSplitPaymentOrdersState,
  useSetSplitPaymentOrdersState,
} from "@/shared/atoms/useSplitPaymentV2Atom";
import useSplitPaymentHook from "./useSplitPaymentHook";

const useSplitPaymentSetupHook = () => {
  const { data } = usePaymentLedgerHook(true);
  const setSplitPaymentStates = useSetSplitPaymentOrdersState();
  const { paymentLedgers, splitCount, splitType } =
    useReadSplitPaymentOrdersState();
  const { createUnpaidLedgers } = useSplitPaymentHook();

  useEffect(() => {
    if (data && data.length > 0) {
      const unpaidLedgers = splitCount
        ? createUnpaidLedgers(data, splitCount).map((ledger) =>
            splitType === "cart" ? { ...ledger, payment_amount: "0" } : ledger
          )
        : [];

      setSplitPaymentStates({
        paymentLedgers: paymentLedgers.map((ledger) => {
          const found = data.find((d) => d.item_id === ledger.item_id);
          return found ? found : ledger;
        }),
        splitType: splitType ?? "custom",
        splitCount: splitCount ?? data.length,
      });
    }
  }, [data, splitCount]);
};

export default useSplitPaymentSetupHook;
